<template>
    <div v-if="showSummary">
        <span class="d-flex align-items-center">
            Mejor calificación:
            <EvaluationGrade :grade="summary?.higher?.note" class="ms-2"/>,
             obtenida el: {{ date }}
        </span>
    </div>
</template>

<script>
import EvaluationGrade from '@/components/shared/Training/Evaluation-grade.vue';
import { formatDateTime } from '@/plugins/complianceScripts';

export default {
    name: "EvaluationSummaryNote",

    components: {
        EvaluationGrade
    },

    props: {
        summary: Object
    },

    computed: {
        showSummary() {
            return this.summary?.higher?.note !== undefined
        },

        date() {
            return formatDateTime(this.summary?.higher?.date ?? new Date());
        }
    },
}
</script>

<style scoped>
.overlay {
    min-height: 30px;
}
</style>